import { Component } from '@angular/core';

@Component({
  selector: 'mnc-empty',
  template: '',
  standalone: true
})
export class EmptyComponent {
}
